import React from 'react';
import { CountdownBanner } from '../components/CountdownBanner';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ReframeSection } from '../components/ReframeSection';
import { ProductSection } from '../components/ProductSection';
import { StackSection } from '../components/StackSection';
import { ValueTable } from '../components/ValueTable';
import { ForYouSection } from '../components/ForYouSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTA } from '../components/FinalCTA';
import { EmotionalClose } from '../components/EmotionalClose';
import { FAQSection } from '../components/FAQSection';
export function SalesPage() {
  return <main className="min-h-screen w-full font-body text-burgundy-800 bg-cream-50 selection:bg-dusty-rose-200 selection:text-burgundy-900" data-id="element-239">
      <CountdownBanner data-id="element-240" />
      <HeroSection data-id="element-241" />
      <PainSection data-id="element-242" />
      <ReframeSection data-id="element-243" />
      <ProductSection data-id="element-244" />
      <StackSection data-id="element-245" />
      <ValueTable data-id="element-246" />
      <ForYouSection data-id="element-247" />
      <TestimonialsSection data-id="element-248" />
      <FinalCTA data-id="element-249" />
      <GuaranteeSection data-id="element-250" />
      <UrgencySection data-id="element-251" />
      <EmotionalClose data-id="element-252" />
      <FAQSection data-id="element-253" />
    </main>;
}